/* @flow */

import hat from 'hat';
import { LoadingActionCreators } from './loading_action_creators';
import { NotificationActionCreators } from './notification_action_creators';
import { FriendlyError } from '../util/friendly_error';

/**
 * Async wraps all actions that require asyncronous HTTP requests
 *
 * @param {Promise} request the promise emitted by the action
 * @param {String} loadingType option for declaring which type of loading to use
 * while request is pending. Options are 'sidebar', 'blocking', 'full', and the noop 'silent'.
 * @param {Function} dispatch dispatch actions for the store
 */
var asyncWrapper = (
  request: Promise<any>,
  loadingType: ?LoadingType,
  dispatch: Function): Promise<any> => {
  var id = hat();
  dispatch(LoadingActionCreators.loadingStart(id, loadingType || 'sidebar'));
  return request
    .catch((err: Object) => {
      dispatch(LoadingActionCreators.loadingStop(id));
      var unhandled = handleError(err, dispatch);
      if (unhandled) throw unhandled;
    })
    .then(val => {
      dispatch(LoadingActionCreators.loadingStop(id));
      return val;
    });
};

/**
 * handleError Wraps all http errors that can be returned
 * by actions.
 *
 * @param {Object} err the error returned by the action
 * @param {Function} dispatch dispatch actions for the store
 * @return {Error} continue error propagation, return undefined if error is fully handled
 */
function handleError(err: Object, dispatch: Function): ?Object {
  if (err.status === 400) {
    dispatch(NotificationActionCreators.error(err));
  } else if (err.status === 401) {
    // propagate reauth errors
    return err;
  } else if (err.status === 403) {
    dispatch(NotificationActionCreators.error(err));
  } else if (err.status === 404) {
    dispatch(NotificationActionCreators.error(err));
  } else if (err.status >= 500) {
    dispatch(NotificationActionCreators.error(new FriendlyError('An unexpected error occurred. Please try again or contact maps@calpoly.edu.', err)));
  } else {
    dispatch(NotificationActionCreators.error(err));
    if (err instanceof FriendlyError && err.cause) {
      err = err.cause;
    }
    console.error('Unhandled error', err);
    //Raven.captureException(err);
  }
  return err;
}

export {
  asyncWrapper,
  handleError
};
